/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 限时抢购项目
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class QueryFlashSaleActivityProductInfoParams {
  constructor(
    public activityId?: string,
    public page?: number,
    public size?: number
  ) {}
}

export default async function (
  params: QueryFlashSaleActivityProductInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Page<cms.flashSaleProjectDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/flashSaleProduct`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
